import React from 'react'

import { getServiceProvisionTypeImage } from './getServiceProvisionTypeImage'
import { DefaultHeader } from '../default-header'
import {
  ServiceProviderCategoryEnum,
  ServiceProvisionTypeEnum,
} from '../../../../../lib/graphql'

export type ServiceProvisionTypeValue = {
  type: ServiceProvisionTypeEnum
  label?: string
}

interface ServiceTypeHeaderProps {
  typeValue: ServiceProvisionTypeValue
  category: ServiceProviderCategoryEnum
  className?: string
}

const ServiceTypeHeader = ({
  typeValue: { type, label },
  category,
  className,
}: ServiceTypeHeaderProps) => {
  const {
    image: { src },
  } = getServiceProvisionTypeImage({ type, serviceProviderCategory: category })

  return <DefaultHeader label={label ?? ''} image={src} className={className} />
}
export default ServiceTypeHeader
